import {Injectable} from '@angular/core';

import {GfxHttpSrv} from './GfxHttpSrv';
import {AppConfig} from './AppConfig';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import swal from 'sweetalert2';
import {GfxStoreService} from './gfx.store.service';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DialogErrorViewComponent} from '../components/dialog-error-view/dialog-error-view.component';
import {MatDialog,} from '@angular/material/dialog';
import {BeMsgErrorComponent} from '../components/be-msg-error/be-msg-error.component';
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class GfxMiscSrv {
    appName: any;

    constructor(
        private modalService: NgbModal,
        private http: GfxHttpSrv,
        private snackBar: MatSnackBar,
        private appConfig: AppConfig,
        private store: GfxStoreService,
        private router: Router,
        private dialog: MatDialog
    ) {
        this.appName = environment.AppName;
    }


    openDialogView(config) {
        const dialogRef = this.dialog.open(DialogErrorViewComponent, config);
        dialogRef.afterClosed().subscribe(result => {
        });
    }


    openSnackBar(msg, classe?, duree?) {
        this.snackBar.open(msg, 'OK', {
            duration: duree ? duree : 3000,
            verticalPosition: 'top',
            panelClass: classe ? classe : '',
        });
    }

    openSnackBarSuccess(msg?, duree?) {
        this.snackBar.open(msg ? msg : this.store.central_msg_success, 'OK', {
            duration: duree ? duree : 2000,
            verticalPosition: 'top',
            panelClass: ['style-success'],
        });
    }

    openSnackBarDelByState() {
        this.openSnackBar(this.store.central_msg_success_del, ['style-danger']);
    }

    getEnvAndToken() {
        const currentUser = this.store.curUser;
        return {
            env: this.store.curUser.env,
            token: currentUser.access_token.toString(),
        };
    }


    openSnackBarBeMsg(config) {
        this.snackBar.openFromComponent(BeMsgErrorComponent, config);
    }

    public renameProp(newKey, oldKey, obj) {
        const renameProp = (oldProp, newProp, {[oldProp]: old, ...others}) => {
            return {
                [newProp]: old,
                ...others,
            };
        };

        return renameProp(newKey, oldKey, obj);
    }


    concat_array_key(array, key, sep) {
        return array.reduce(function (cnt, o) {
            return cnt ? cnt + sep + o[key] : cnt + o[key];
        }, '');
    }

    get_n_fst_letters(strOrArr, letterNbr, key?) {
        let str;
        if (!strOrArr) {
            return '';
        }
        if (key) {
            str = this.concat_array_key(strOrArr, key, ', ');
        } else {
            str = strOrArr;
        }

        str =
            str.length <= letterNbr
                ? str.substring(0, letterNbr)
                : str.substring(0, letterNbr) + '...';

        return str;
    }

    dtMillisToFr(dtMs) {
        const date = new Date(dtMs); // Date 2011-05-09T06:08:45.178Z
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        return `${day}/${month}/${year}`;
    }

    secToFrDateStr(secs) {
        const date = new Date(secs * 1000);
        return (
            date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
        );
    }

    confirmDialog(title, confirmButtonText, cancelButtonText, type?, text?) {
        return swal({
            title: title,
            text: text ? text : '',
            type: type ? type : 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-danger',
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            buttonsStyling: false,
        });
    }

    msgDialog(msg, text?) {
        swal({
            title: msg,
            text: text ? text : '',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
        }).catch(swal.noop);
    }

    formatNumber(number) {
        return new Intl.NumberFormat('fr-IN').format(number);
    }


    sortArr(arr, key, desc = false) {
        let sortedArr;
        if (desc) {
            sortedArr = arr.sort((a, b) =>
                a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0
            );
        } else {
            sortedArr = arr.sort((a, b) =>
                a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0
            );
        }
        return sortedArr;
    }

    isoDateToDate(isoStr): any {
        if (!isoStr) {
            return '';
        }
        return new Date(isoStr);
    }

    isoDateToFrStr(isoStr) {
        if (!isoStr) {
            return;
        }
        let date = new Date(isoStr);
        return (
            date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
        );
    }

    momentToIsoDate(moment) {
        return moment.toISOString();
    }


    formatNumberMnt(value, noVirgule?) {
        let res = (Math.round(value * 100) / 100).toFixed(2);
        let resRounded;
        if (noVirgule) {
            resRounded = parseInt(res);
        } else {
            resRounded = parseFloat(res);
        }
        return resRounded.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
    }

    public dataUrlToFileList(dataUrl: string, fileName: string): FileList {
        const fileArray: File[] = [];
        const blobObject = this.dataUrlToBlob(dataUrl);

        const file = new File([blobObject], fileName);
        fileArray.push(file);

        return fileArray as unknown as FileList;
    }

    public dataUrlToBlob(dataUrl: string): Blob {

        const byteString = atob(dataUrl.split(',')[1]);


        const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0];


        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);


        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }


        const blob = new Blob([ia], {type: 'image/png'});
        return blob;
    }

    removeAccents(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    parseDate(dateString: string): Date {
        const parts = dateString.split('/');
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Months are zero-based in JavaScript
        const year = parseInt(parts[2], 10);
        return new Date(year, month, day);
    }

    convertYYMMDDToDate(dateString: string): Date | null {
        if (dateString.length !== 6 || isNaN(Number(dateString))) {
            return null;
        }

        const year = parseInt(dateString.substring(0, 2));
        const month = parseInt(dateString.substring(2, 4)) - 1;
        const day = parseInt(dateString.substring(4, 6));
        const fullYear = year < 50 ? 2000 + year : 1900 + year;

        return new Date(fullYear, month, day);
    }

    getDifferenceBetweenStrings(firstString, secondString) {
        firstString = [...firstString].sort();
        secondString = [...secondString].sort();
        return secondString.find((char, i) => char !== firstString[i]);
    }

    createDateFromFrenchFormatString(dateString: string): Date {
        const parts = dateString.split('/');
        if (parts.length !== 3) {
            throw new Error('Invalid date format. Expected dd/MM/yyyy.');
        }

        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        if (isNaN(day) || isNaN(month) || isNaN(year)) {
            throw new Error('Invalid date components. Could not parse numbers.');
        }

        return new Date(year, month, day);
    }


}
